<mbs-sidepanel
  side="right"
  [actionNames]="{
    close: 'shared:buttons.cancel' | i18next
  }"
  [id]="SidepanelId.ConnectSettings"
  [isCreate]="false"
  [loadingData]="isLoading()"
  [showDelete]="false">
  <div
    class="mbs-sidepanel_title"
    header-title>
    <div>
      <span [ngClass]="[computer | computerOsIcon, computer?.online ? 'text-primary' : 'text-muted']"></span>
    </div>
    <div class="mbs-sidepanel_title-name ml-3">
      {{ getComputerName() }}
    </div>
    <div class="ml-2 text-xs text-gray">({{ getComputerStatus() }})</div>
  </div>
  <div body>
    <div class="mbs-from_group mb-4">
      <p class="mb-2">{{ 'shared:agentOptions.connectOptions.header' | i18next }}</p>
      <div class="mbs-form-group">
        <mbs-group-button
          class="w-100"
          customClasses="w-100">
          <mbs-button
            class="flex-basis-50"
            customClasses="w-100 justify-content-center"
            [active]="useGlobal.value"
            [type]="'secondary'"
            (click)="useGlobal.patchValue(true)">
            {{
              hasCompanySettings()
                ? ('shared:agentOptions.connectOptions.useCompany' | i18next)
                : ('shared:agentOptions.connectOptions.useGlobal' | i18next)
            }}
          </mbs-button>
          <mbs-button
            class="flex-basis-50"
            customClasses="w-100 justify-content-center"
            [active]="!useGlobal.value"
            [type]="'secondary'"
            (click)="useGlobal.patchValue(false)">
            {{ 'shared:agentOptions.connectOptions.useCustom' | i18next }}
          </mbs-button>
        </mbs-group-button>
      </div>

      <mbs-alert
        *ngIf="isGlobalSettingsVisible() && ('AccessToAllCompanies' | can: 'read') && ('ManageCompanies' | can: 'read')"
        class="my-3"
        [type]="alertType.info">
        {{
          hasCompanySettings()
            ? ('shared:agentOptions.connectOptions.toEditCompanyOptions' | i18next)
            : ('shared:agentOptions.connectOptions.toEditOptions' | i18next)
        }},
        <a [href]="getGlobalOptionsEditUrl()">
          {{ 'shared:buttons.clickHere' | i18next }}
          <span class="fa fa-link text-info"></span>
        </a>
      </mbs-alert>
    </div>

    <mbs-connect-settings-form
      [form]="form"
      [formState]="useGlobal?.value ? parentAgentSettingsFormState : formState"
      [mode]="'panel'"></mbs-connect-settings-form>
  </div>
</mbs-sidepanel>
